import { render, staticRenderFns } from "./order_gift_status.vue?vue&type=template&id=01c05a78&scoped=true&"
import script from "./order_gift_status.vue?vue&type=script&lang=js&"
export * from "./order_gift_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c05a78",
  null
  
)

export default component.exports